import {Filter} from "../filters_handler";
import {toLonLat, transformExtent} from "ol/proj";

export const filterToURLSearchParams = (filter: Filter): URLSearchParams => {
  console.log(JSON.stringify(filter));

  if (!filter.zoom || !filter.center || !filter.extent) { throw new Error('Missed required filter arguments (zoom or center or extent)'); }

  const transformedExtent = transformExtent(filter.extent, 'EPSG:3857', 'EPSG:4326');
  const bbox = transformedExtent.join(',');

  let filterSearchParams = new URLSearchParams({
    bbox: bbox,
    zoom: filter.zoom.toString(),
    center: toLonLat(filter.center).toString()
  });

  for (const [key, values] of Object.entries(filter.checkboxes)) {
    values.forEach((value) => {
      filterSearchParams.append(key, value);
    });
  }

  for (const [key, value] of Object.entries(filter.inputs)) {
    filterSearchParams.append(key, value);
  }

  return filterSearchParams;
}